import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PasswordResetPage.css';
import {  sendPasswordResetEmail } from "firebase/auth";
import { auth } from '../config/firebase-config';
import axios from 'axios';

const PasswordResetPage = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(''); // New state for error message
  const navigate = useNavigate();

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setErrorMessage(''); // Reset error message
    try {
      const user = await axios.get(`${process.env.REACT_APP_SERVER_URL}/globalrouter/get-user/${email}`);
      console.log(user);
      if(user.data){
        await sendPasswordResetEmail(auth, email)
        .then(() => {
          console.log('Password reset email sent to:', email);
          setIsSubmitted(true);
        })
      }
    } catch (error) {
      setErrorMessage('Invalid User Email');
    }
  };

  const handleBackToLogin = () => {
    navigate('/');
  };

  return (
    <div className="password-reset-container">
      <h1 className="branding">ZYVORA</h1>
      <div className="card">
        <h2>Reset Password</h2>
        <form onSubmit={handlePasswordReset}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {isSubmitted && <p className="success-message">Reset Link sent successfully</p>}
          {errorMessage && <p className="error-message">{errorMessage}</p>} {/* Display error message */}
          <button type="submit" onClick={isSubmitted ? handleBackToLogin : undefined}>
            {isSubmitted ? 'Back to Login' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetPage;